import script from "./OrderHistoryGoods.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHistoryGoods.vue?vue&type=script&setup=true&lang=js"

import "./OrderHistoryGoods.vue?vue&type=style&index=0&id=528609f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-528609f4"]])

export default __exports__